// extracted by mini-css-extract-plugin
export default {"active":"dot_active__ea4NN","inactive":"dot_inactive__xRyCn"};